import React, { Component } from "react";
import Header from "./Header";
import SideBar from "./SideBar";

export default class Master extends Component {
  render() {
    return (
      <div>
        <Header pathname={this.props.pathname}/>
        <SideBar />
      </div>
    );
  }
}
